import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d98bdc7c"
import script from "./gstrSummaryData.js?vue&type=script&lang=js&external"
export * from "./gstrSummaryData.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=d98bdc7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports